<template>
	<div>
		<div class="inbox">
			<bsf-page-header>
				<h3 slot="header">layout 布局 </h3>
			</bsf-page-header>
			<breadcrumb :data="$store.state.bcArray"></breadcrumb>
		</div>
		<div class="container-fluid">
			<bsf-layout>
				<bsf-col size="xs" col="12">
					<bsf-panel>
						<h5 class="panel-title" slot="title">布局</h5>
						<template slot="body">
							<bsf-layout>
								<bsf-col size="xs" col="4">4</bsf-col>
								<bsf-col size="xs" col="8">8</bsf-col>
							</bsf-layout>
						</template>
						<bsf-doc>
							<bsf-docmix>
								<h5 slot=""></h5>
							</bsf-docmix>
						</bsf-doc>
					</bsf-panel>
				</bsf-col>
				<bsf-col size="xs" col="6">
					<bsf-panel>
						<h5 class="panel-title" slot="title">图表 Echart</h5>
						<template slot="body">
							<bsf-chart></bsf-chart>
						</template>
					</bsf-panel>
				</bsf-col>
			</bsf-layout>
		</div>
	</div>
</template>
<script>
	import bsfLayout from "components/css/layout"
	import bsfCol from "components/css/col"
	//
	import bsfPanel from 'components/comp/panel'
	import bsfPageHeader from 'components/comp/pageheader'
	import breadcrumb from 'components/comp/breadcrumbs'
	import bsfChart from 'components/comp/chart'
	//
	export default {
		components: {
			bsfLayout,
			bsfCol,
			//
			bsfPageHeader,
			breadcrumb,
			bsfPanel,
			bsfChart
		},
		data() {
			return {
				navdata1: [{
					name: "Home",
					href: ""
				}, {
					name: "Profile",
					href: ""
				}, {
					name: "Message",
					href: "",
					active: true
				}],
			}
		}
	}
</script>
<style lang="less">
	@import (reference) "../assets/lib/css.less";
	.inbox {
		.bdrb;
		.mgb;
		background-color: @cwh;
		.pd(@mpb 2*@mpb);
		.page-header {
			.mgb(@mpb/3);
		}
		.breadcrumb {
			.mgb(0)
		}
	}
</style>


// WEBPACK FOOTER //
// grid.vue?1f926529